const MEDIA_QUERIES = {
  small: "(max-width: 480px)",
  medium: "(max-width: 768px)",
  large: "(min-width: 768px)",
};

export class MediaQueryController extends window.StimulusController {
  connect() {}

  disconnect() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  #matchMedia(breakpoint) {
    return window.matchMedia(MEDIA_QUERIES[breakpoint]).matches;
  }

  get activeBreakpoint() {
    return Object.keys(MEDIA_QUERIES).find((breakpoint) =>
      this.#matchMedia(breakpoint),
    );
  }

  onWindowResize(callback) {
    let timeoutId;

    this.resizeObserver = new ResizeObserver(() => {
      clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        callback(this.activeBreakpoint);
      }, 250);
    });

    this.resizeObserver.observe(document.body);
  }
}
